// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.print-container[data-v-0f5c1bce] {\n  background-color: darkgrey;\n  width: 100%;\n  margin: 0;\n}\n.print-container .print-div[data-v-0f5c1bce] {\n  border: solid black 1px;\n  width: 8.75in;\n  margin: auto;\n  padding: .2in;\n  background-color: white;\n}\n.print-container .print-toolbar[data-v-0f5c1bce] {\n  position: relative;\n  top: -40px;\n  background-color: antiquewhite;\n  margin-right: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
